import Vue from 'vue'
import Router from 'vue-router'
import AutoRouter from 'vue-router-auto'
import Cookies from 'js-cookie'

window.CookieManage = Cookies;
Vue.use(Router)

let routes = AutoRouter({
  rc: require.context('@/pages', true, /\.vue$/),
  redirect: '/login',
  rootFile: 'pages',
})

let router = new Router({
  // mode: 'history',
  base: '/',
  routes,
})

//注册一个全局前置守卫,确保要调用 next 方法，否则钩子就不会被 resolved
router.beforeEach((to, from, next) => {
  if (to.path != '/login' && !CookieManage.get('live-token')) {
    return next({
      path: '/login'
    })
  }else{
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js